var path = 'views/templates/groupBucketQuota.html';
var html = "<div class=\"group-bucket-quota-text\" ng-show=\"$ctrl.initialized\">{{$ctrl.byteCountDisplay}}</div> ";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;